<!-- Send Message Modal  -->
<p-dialog [(visible)]="createSmsModal" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '550px'}" styleClass="no-header-modal">
  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
      <ng-container *ngIf="{client: allClientData$ | async,tenants: getAccessTenantList$ | async,smsTemplate: allSmsTemplates$ | async} as $">
          <!-- Header -->
          <div class="py-2 px-3 flex align-items-center justify-content-between border-bottom-1 border-300">
              <h2 class="mb-0 text-base font-normal flex align-items-center">
                  {{'SMS.SEND_SMS_TO' | translate}}
                  <span class="hidden sm:inline-flex align-items-center">
                      <p-avatar *ngIf="!$.client.image" [label]="$.client.full_name | titlecase | shortName" shape="circle" styleClass="mx-2"></p-avatar>
                      <p-avatar *ngIf="$.client.image" [image]="$.client.image" shape="circle" styleClass="mx-2"></p-avatar>
                      <strong>{{$.client.full_name}} </strong><span class="text-xs text-600">&nbsp; - {{$.client.id}}</span>
                  </span>
              </h2>

              <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closeDialogEvent()"></div>
          </div>
          <!-- Header -->
          <div class="flex align-items-center sm:hidden p-2 border-bottom-1 border-300">
              <p-avatar *ngIf="!$.client.image" [label]="$.client.full_name | titlecase | shortName" shape="circle" styleClass="mx-2"></p-avatar>
              <p-avatar *ngIf="$.client.image" [image]="$.client.image" shape="circle" styleClass="mx-2"></p-avatar>
              <strong>{{$.client.full_name}}</strong>
              <span class="text-xs text-600">&nbsp; - {{$.client.id}}</span>
          </div>
          <!-- Modal Content -->
          <form [formGroup]="smsFormGroup" (ngSubmit)="SendMessage()">
              <div class="surface-50 p-3">
                  <h5 class="font-medium text-700 text-xs mb-3 block uppercase">{{'SMS.CHOOSE_MSG_TYPE' | translate}}</h5>

                  <!-- Buttons -->
                  <div class="sm:flex -mx-2">
                      <!-- App Notification -->
                      <div class="sm:w-4 sm:mx-2 my-2 sm:my-0 border-round p-2 shadow-2 flex align-items-center oppacity-40">
                          <div class="bg-primary border-round flex align-items-center justify-content-center h-2rem w-2rem">
                              <i class="fa fa-phone"></i>
                          </div>
                          <strong class="text-xs ml-2">{{'SMS.APP_NOTIFICATION' | translate}}</strong>
                      </div>
                      <!-- App Notification -->

                      <!-- WhatsApp -->
                      <div [ngClass]="sendWhatsApp ? 'bg-primary text-white' : 'surface-0'" class="sm:w-4 sm:mx-2 my-2 sm:my-0 border-round p-2 shadow-2 flex align-items-center" (click)="toggleSendMsgContent()"
                          (click)="sendWhatsApp=true;">
                          <div class="bg-primary border-round flex align-items-center justify-content-center h-2rem w-2rem">
                              <i class="fab fa-whatsapp"></i>
                          </div>
                          <strong class="text-xs ml-2">{{'SMS.WHATSUP_NOTIFICATION' | translate}}</strong>
                      </div>
                      <!-- WhatsApp -->

                      <!-- SMS -->
                      <div [ngClass]="sendSMS ? 'bg-primary text-white' : 'surface-0' "
                          class="sm:w-4 sm:mx-2 my-2 sm:my-0 border-round p-2 shadow-2 flex align-items-center"
                          (click)="toggleSendMsgContent()"
                          (click)="sendSMS=true">
                          <div class="bg-primary border-round flex align-items-center justify-content-center h-2rem w-2rem">
                              <i class="fa fa-comments"></i>
                          </div>
                          <strong class="text-xs ml-2">{{'SMS.SMS' | translate}}</strong>
                      </div>
                      <!-- SMS -->
                  </div>
                  <!-- Buttons -->

                  <!-- Empty State -->
                  <div *ngIf="sendMessageDefaultState" class="text-center mt-6">
                      <h5 class="mb-4 text-base font-normal text-600">{{'SMS.SELECT_MSG_TYPE' | translate}}</h5>
                      <img src="/assets/img/no-data-img.svg" alt="Image" class="block mx-auto w-13rem sm:w-18rem" />
                  </div>
                  <!-- Empty State -->

                  <!-- App Notification State -->
                  <div *ngIf="!sendMessageDefaultState" class="mt-3">
                      <div class="mb-4">
                          <p-message severity="warn" icon="fa fa-exclamation-circle" aria-label="sms-warning-message">
                                  <div class="p-warn flex align-items-center w-full -my-2">
                                      <i class="fa fa-exclamation-circle p-warn text-xl"></i>
                                      <div class="ml-3 line-height-3 text-xs">
                                          <span *ngIf="sendSMS && $.client.promotional_sms">{{'SMS.MSG_INFO' | translate}}</span>
                                          <span *ngIf="sendSMS && !$.client.promotional_sms">{{'SMS.MSG_INFO_SMS' | translate}}</span>
                                          <span *ngIf="sendWhatsApp && $.client.promotional_whatsapp">{{'SMS.MSG_INFO' | translate}}</span>
                                          <span *ngIf="sendWhatsApp && !$.client.promotional_whatsapp">{{'SMS.MSG_INFO_WHATSAPP' | translate}}</span>
                                      </div>
                                  </div>
                          </p-message>
                      </div>

                      <label class="font-medium text-700 text-xs mb-3 block uppercase" *ngIf="sendMobileNotification">
                          {{'SMS.COMPOSE_NOT_MSG' | translate }}
                      </label>
                      <label class="font-medium text-700 text-xs mb-3 block uppercase" *ngIf="!sendMobileNotification">
                          {{'SMS.COMPOSE_MSG' | translate }}  <a  href="tel:{{ $.client.mobile_country_code+$.client.mobile_number }}">{{ $.client.mobile_country_code+$.client.mobile_number}}</a>
                         
                      </label>

                      <textarea [style]="{'height':'180px'}" class="w-full" [placeholder]="'SMS.PLACEHOLDER' | translate : {size:textSize}" formControlName="content"> </textarea>
                      <app-error-msg
                       styleClass="md:block"
                        *ngIf="ContentFormControl.dirty && ContentFormControl.invalid"
                        [errors]="ContentFormControl.errors"
                        [fieldLabel]="'SMS.CONTENT' | translate">
                      </app-error-msg>
                      <div class="flex align-items-center justify-content-between text-xs mt-3">
                          <div class="flex align-items-center">
                              <p-toggleSwitch formControlName="is_marketing_msg"></p-toggleSwitch>
                              <label class="ml-3 -mt-1 flex align-items-center">
                                  {{'SMS.MSG_INFO_2' | translate }} <i class="fa fa-question-circle font-light text-base text-400 cursor-pointer" pTooltip="This is a sample!" tooltipStyleClass="text-xs"></i>
                              </label>
                          </div>
                          <div [innerHtml]="'SMS.TEXT_SIZE' | translate :{size:textSize}"></div>
                      </div>
                  </div>
                  <!-- App Notification State -->
              </div>
              <!-- Modal Content -->

              <!-- Modal Footer -->
              <div class="p-3 border-top-1 border-300 flex align-items-center justify-content-between">
                  <div class="w-4">
                      <p-button (click)="closeDialogEvent()" [label]="'SMS.CANCEL' | translate" styleClass="p-button-link text-sm"></p-button>
                  </div>
                  <div class="w-8 text-right">
                      <button
                          type="submit"
                          [disabled]="!smsFormGroup.valid || !IsClientPermission()"
                          [loading]="btnLoading"
                          pButton
                          pRipple
                          [label]="'SMS.BTN_MSG' | translate"
                          class="text-sm md"
                      ></button>
                  </div>
              </div>
          </form>
          <!-- Modal Footer -->
      </ng-container>
  </ng-template>
</p-dialog>
<!-- Send Message Modal -->

